import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function ClosingSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-24 px-4 bg-surface relative border-t border-white/5" data-id="element-33">
      <div className="max-w-5xl mx-auto" data-id="element-34">
        <div className="text-center mb-10 sm:mb-16" data-id="element-35">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-text mb-6" data-id="element-36">
            Tienes dos caminos ahora mismo...
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-8 mb-10 sm:mb-16" data-id="element-37">
          {/* Path A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-background/50 p-8 rounded-2xl border border-white/5 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-38">
            <div className="flex items-center gap-3 mb-6" data-id="element-39">
              <XCircleIcon className="w-6 h-6 text-textMuted" data-id="element-40" />
              <h3 className="text-xl font-serif text-textMuted" data-id="element-41">
                Camino A: El Status Quo
              </h3>
            </div>
            <p className="text-textMuted leading-relaxed" data-id="element-42">
              Seguir mirando esa pared vacía de tu casa o seguir desperdiciando
              dinero en decoraciones baratas que no te emocionan. Seguir
              frustrándote con tutoriales incompletos.
            </p>
          </motion.div>

          {/* Path B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-surfaceLight p-8 rounded-2xl border border-accent shadow-[0_0_30px_rgba(212,168,83,0.15)] relative overflow-hidden" data-id="element-43">
            <div className="absolute top-0 right-0 w-32 h-32 bg-accent/10 blur-3xl rounded-full" data-id="element-44"></div>
            <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-45">
              <CheckCircleIcon className="w-6 h-6 text-accent" data-id="element-46" />
              <h3 className="text-xl font-serif text-accent" data-id="element-47">
                Camino B: La Decisión Inteligente
              </h3>
            </div>
            <p className="text-text leading-relaxed relative z-10" data-id="element-48">
              Invertir menos de lo que cuesta una pizza, aprender una habilidad
              meditativa que impresiona a todos, y tener tu primera escultura de
              lujo terminada esta misma noche.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-49">
          <button onClick={scrollToPricing} className="group relative inline-flex items-center justify-center gap-3 bg-accent text-background px-10 py-5 rounded-xl font-bold text-xl transition-all hover:bg-accentHover hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_rgba(212,168,83,0.3)]" data-id="element-50">
            <span data-id="element-51">Tomar el Camino B por $9.99</span>
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-52" />
          </button>
        </div>
      </div>
    </section>;
}